import { BaseRequests } from "../../../config/BaseRequests";
import { notificationsApiEndpoints } from "../api/notifications.api";
import {
  NotificationRow,
  SendNotificationDto,
  SendNotificationResponse,
} from "../dto/index.dto";
import { PaginatedResponse } from "../../../shared/dto/pagination.dto";

export class NotificationsService {
  static getNotifications = (
    page: number,
    limit: number
  ): Promise<PaginatedResponse<NotificationRow>> =>
    BaseRequests.get(notificationsApiEndpoints.getNotifications(page, limit));

  static sendNotification = (
    data: SendNotificationDto
  ): Promise<SendNotificationResponse> =>
    BaseRequests.post(notificationsApiEndpoints.sendNotification, data);

  static deleteNotification = (id: number): Promise<void> =>
    BaseRequests.delete(notificationsApiEndpoints.deleteNotification(id));
}
